

const swiper = new Swiper('.carousel-slider', {
  slidesPerView: 1.1,
  spaceBetween: 20,
  pagination: {
    el: '.swiper-pagination-carousel',
     clickable: true,
  },
  breakpoints: {
      991: {
          slidesPerView: 3,
          spaceBetween: 30
      },
      749: {
          slidesPerView: 2,
          spaceBetween: 20
      }
  }
});


const swiper2 = new Swiper('.blog_post_slider', {
  slidesPerView: 1,
   pagination: {
    el: '.swiper-pagination-blog',
     clickable: true,
  },
});

const swiper3 = new Swiper('.slider-column-row', {
  slidesPerView: 1,
   pagination: {
    el: '.swiper-pagination-image',
     clickable: true,
  },
});


const swiper4 = new Swiper('.blog-post-swiper', {
  slidesPerView: 1,
  spaceBetween: 20,
  pagination: {
    el: '.swiper-pagination-image',
     clickable: true,
  },
 navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
      991: {
          slidesPerView: 3,
          spaceBetween: 30
      },
      749: {
          slidesPerView: 2,
          spaceBetween: 20
      }
  }
});



